(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './ktor-ktor-utils.js', './kotlinx-coroutines-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./ktor-ktor-utils.js'), require('./kotlinx-coroutines-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-events'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-events'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-events'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-events'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-events'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-events'.");
    }
    globalThis['ktor-ktor-events'] = factory(typeof globalThis['ktor-ktor-events'] === 'undefined' ? {} : globalThis['ktor-ktor-events'], globalThis['ktor-ktor-utils'], globalThis['kotlinx-coroutines-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_io_ktor_ktor_utils, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var LockFreeLinkedListNode = kotlin_io_ktor_ktor_utils.$_$.f;
  var DisposableHandle = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b3;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var CopyOnWriteHashMap = kotlin_io_ktor_ktor_utils.$_$.c;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var equals = kotlin_kotlin.$_$.sf;
  var addSuppressed = kotlin_kotlin.$_$.eo;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(HandlerRegistration, 'HandlerRegistration', VOID, LockFreeLinkedListNode, [DisposableHandle]);
  initMetadataForClass(Events, 'Events', Events);
  initMetadataForClass(EventDefinition, 'EventDefinition', EventDefinition);
  //endregion
  function HandlerRegistration() {
  }
  function Events() {
    this.tsu_1 = new CopyOnWriteHashMap();
  }
  protoOf(Events).usu = function (definition, value) {
    var exception = null;
    var tmp0_safe_receiver = this.tsu_1.iy(definition);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'io.ktor.util.internal.LockFreeLinkedListHead.forEach' call
      var tmp = tmp0_safe_receiver.c1o();
      var cur = tmp instanceof LockFreeLinkedListNode ? tmp : THROW_CCE();
      while (!equals(cur, tmp0_safe_receiver)) {
        if (cur instanceof HandlerRegistration) {
          var registration = cur;
          try {
            var tmp_0 = registration.wsu_1;
            (typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE())(value);
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              var tmp0_safe_receiver_0 = exception;
              var tmp_1;
              if (tmp0_safe_receiver_0 == null) {
                tmp_1 = null;
              } else {
                addSuppressed(tmp0_safe_receiver_0, e);
                tmp_1 = Unit_instance;
              }
              if (tmp_1 == null) {
                // Inline function 'kotlin.run' call
                exception = e;
              }
            } else {
              throw $p;
            }
          }
        }
        cur = cur.vsr();
      }
    }
    var tmp1_safe_receiver = exception;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  };
  function EventDefinition() {
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = EventDefinition;
  _.$_$.b = Events;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-events.js.map
